<div class="footer" [ngClass]="{'ameyoZindex':userDetail.rights?.ameyo_on_top}">

   
<!-- <div *ngIf="( (userDetail?.rights?.ameyo_calling) || userDetail?.is_ameyo_required) && is_ameyoEnabledSession"><app-ameyo-calling [hidden]="!this.userDetail || currentUrl == '/'"></app-ameyo-calling></div> -->
<div class="m-auto text-center">&#169; REDTAPE {{todayDate | date:"YYYY"}} (Version {{appVersion}})</div>
<div>
    <ng-container *ngIf="this.userDetail && currentUrl != '/'">
        <div class="check-list-page" *ngIf="!isShowLeadpage" [@animation]>
            <app-lead-check-list></app-lead-check-list>
        </div>

        <div class="d-flex gap-1 left-buttons">
            <!-- <div class="footer-buttons btn btn-info border-bottom-0"
                (click)=" isShowLeadpage = !isShowLeadpage">
                <i class="bi"
                    [ngClass]="{'bi-x': !isShowLeadpage, 'bi-list-check': isShowLeadpage,  'm-1': isShowLeadpage}"></i><span
                    class="cons">
                    {{isShowLeadpage ? 'Check List': 'Close'}}</span>
            </div> -->
            <!-- <div class="footer-buttons btn btn-info border-bottom-0">
                <a class="text-decoration-none text-info" (click)="goToLims('https://report-status.azurewebsites.net/ui/')" href="javascript:void(0)"><i class="bi bi-link-45deg"></i> <span class="cons">Lims Utility</span></a>
            </div> -->
            <!-- <div class="footer-buttons btn btn-info border-bottom-0">
                <a class="text-decoration-none text-info" href="javascript://" (click)="goToLims('')"
                    target="_blank"><i class="bi bi-link-45deg"></i> <span class="cons">Lims Utility</span></a>
            </div> -->
            <!-- <div class="footer-buttons btn btn-info border-bottom-0">
                <a class="text-decoration-none text-info" href="https://edos.redtape.com/" target="_blank"><i
                        class="bi bi-link-45deg"></i> <span class="cons">Edos</span></a>
            </div> -->
        </div>


    </ng-container>
</div>
    
    
    

    


</div>